(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-om-locale-theme]';
  const context = document.querySelector(selector);
  if (!context) return;
  const key = `om-locale-filters:${context.dataset.omLocaleTheme}`;
  const allowedPage = el => el.dataset.omLocalePage === 'search' || (el.dataset.omLocalePage === 'collection' && !!el.dataset.omLocaleResource);
  const scope = el => `${el.dataset.omLocalePage}:${el.dataset.omLocaleResource}:${el.dataset.omLocaleCountry}`;
  const colorKeys = new Set(['filter.p.m.custom.color_family', 'filter.v.option.color', 'filter.v.option.colour', 'filter.v.option.اللون', 'filter.v.option.لون']);
  const cleanSearch = search => search.replace(/^\?/, '').split('&').filter(pair => {
    if (!pair) return false;
    const name = decodeURIComponent(pair.split('=')[0].replace(/\+/g, ' '));
    return name !== 'page' && name !== 'section_id' && !colorKeys.has(name.toLowerCase());
  }).join('&');
  const queryMatches = (saved, current) => {
    const before = new URLSearchParams(cleanSearch(saved));
    const after = new URLSearchParams(cleanSearch(current));
    const keys = [...new Set(before.keys())];
    if (keys.length !== new Set(after.keys()).size) return false;
    return keys.every(name => {
      const expected = before.getAll(name);
      const actual = after.getAll(name);
      return JSON.stringify(expected) === JSON.stringify(actual) || (expected.length > 1 && actual.length === 1 && actual[0] === expected[expected.length - 1]);
    });
  };
  try {
    const raw = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    if (raw) {
      const saved = JSON.parse(raw);
      const age = Date.now() - saved.at;
      if (allowedPage(context) && saved.origin === location.origin && saved.scope === scope(context) && saved.locale === context.dataset.omLocaleCode && age >= 0 && age < 120000 && typeof saved.search === 'string' && saved.search.length <= 16000 && queryMatches(saved.search, location.search)) {
        const target = new URL(location.href);
        target.search = cleanSearch(saved.search);
        if (target.href !== location.href) {
          location.replace(target.href);
          return;
        }
      }
    }
  } catch (_) {}
  document.addEventListener('submit', event => {
    const form = event.target;
    const local = form.closest(selector);
    const button = event.submitter;
    if (event.defaultPrevented || !local || !allowedPage(local) || !form.matches('form.shopify-localization-form') || !button || button.name !== 'locale_code' || button.form !== form || !button.value || button.value === local.dataset.omLocaleCode) return;
    try {
      sessionStorage.removeItem(key);
      const params = new URLSearchParams(location.search);
      const repeated = [...params.keys()].some(name => name.startsWith('filter.') && !colorKeys.has(name.toLowerCase()) && params.getAll(name).length > 1);
      if (!repeated) return;
      const search = cleanSearch(location.search);
      if (search.length > 16000) return;
      sessionStorage.setItem(key, JSON.stringify({ origin: location.origin, scope: scope(local), locale: button.value, search, at: Date.now() }));
    } catch (_) {}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
